export default __webpack_public_path__ + "static/media/nodeJS.c5e5c356.svg";